import {
	SUBMIT_MESSAGE,
	DELETE_MESSAGE,
	CLEAR_MESSAGES,
	SET_CHAT_STATUS,
	VIEW_CHAT,
	VIEW_SETTINGS,
	UPDATE_SCREEN_NAME,
	UPDATE_AVATARS,
	UPDATE_AVATAR,
	UPDATE_LWC_FEED
} from 'constants';

export const submitMessage = (message) => {
	return {
		type : SUBMIT_MESSAGE,
		payload : {...message}
	}
}

export const updateLWCFeed = (url) => {
	return {
		type: UPDATE_LWC_FEED,
		payload: url
	}
}

// message must contain the timestamp of the message to properly delete from redis.
export const deleteMessage = (message) => {
	console.log('in action creator', message)
	return  {
		type : DELETE_MESSAGE,
		payload : message
	}
}

export const clearMessages = () => {
	return {
		type : CLEAR_MESSAGES,
		payload : {}
	}
}

export const setChatStatus = ({enabled}) => {
	return {
		type : SET_CHAT_STATUS,
		payload : {enabled}
	}
}

export const viewChat = () => {
	return {
		type: VIEW_CHAT,
		payload: {
			viewSettings: false
		}
	}
}

export const viewSettings = () => {
	return {
		type: VIEW_SETTINGS,
		payload: {
			viewSettings: true
		}
	}
}
/** Takes string of new screen_name. */
export const updateScreenName = ({id, screen_name}) => {
	return {
		type : UPDATE_SCREEN_NAME,
		payload : {id, screen_name}
	}
}

export const updateAvatars = ({avatars}) => {
	return {
		type : UPDATE_AVATARS,
		payload : {avatars}
	}
}

export const updateAvatar = ({avatar, id}) => ({
	type : UPDATE_AVATAR,
	payload : {id, avatar}
});



// WEBPACK FOOTER //
// ./src/common/actions/live_weather_center.js